import Observer from "./Observer";

/**
 * Is an abstract class for subjects that after specified event notifies all observers.
 *
 * @see Observer
 */
 export default class AObservableSubject {

  /**
   * Constructor
   */
  constructor() {
    this.observers = [];
  }

  /**
   * Registers new observer.
   *
   * @param {Function} callback that will be fired on update
   * ! If we want to use callback in instance, we need to bind it when passing to constructor
   */
  register(callback) {
    this.observers.push(new Observer(callback));
  }

  /**
   * Will notify all available observers.
   */
  notify() {
    this.observers.forEach( observer => {
      observer.update();
    });
  }
}
